import { IAction, IState } from './UseReportableDataContext';
import { getComparisonFromToUrlSegment, getFromToUrlSegment, getQueryString } from '../utils/mapping';
import { timeNow } from '../utils/dates';

export type ActionTypes =
  | 'CLEAR_ERROR'
  | 'ERROR_ALL_SITES'
  | 'FINISH_LOADING'
  | 'SET_ALL_SITES'
  | 'SET_BASE_CURRENCY'
  | 'SET_COMPARISON'
  | 'SET_CURRENCY_FILTER'
  | 'SET_DATE_RANGE_FILTER'
  | 'SET_GRANULARITY'
  | 'SET_LOADING'
  | 'SET_COMPARISON_SALES_TOTALS'
  | 'SET_SALES_TOTALS'
  | 'SET_SITES'
  | 'STORE_CURRENCIES'
  | 'START_LOADING'
  | 'UPDATE_COMPARISON_DATE_TARGET'
  | 'UPDATE_DATE_TARGET'
  | 'UPDATE_QUERYSTRING';

export function ReportableDataReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'START_LOADING':
      newState = {
        ...state,
        loading: true,
      };
      break;
    case 'FINISH_LOADING':
      newState = {
        ...state,
        loading: false,
      };
      break;
    case 'SET_BASE_CURRENCY':
      newState = {
        ...state,
        graphParameters: {
          ...state.graphParameters,
          baseCurrency: payload.baseCurrency,
        },
      };
      break;
    case 'SET_COMPARISON':
      newState = {
        ...state,
        queryParameters: {
          ...state.queryParameters,
          comparisonDateRange: payload.comparisonDateRange,
          comparisonDateRangeOffset: payload.comparisonDateRangeOffset,
          comparisonType: payload.comparisonType,
        },
        graphParameters: {
          ...state.graphParameters,
          comparisonEnabled: payload.comparisonEnabled,
        },
      };
      break;
    case 'SET_CURRENCY_FILTER':
      newState = {
        ...state,
        queryParameters: {
          ...state.queryParameters,
          filterCurrency: payload.filterCurrency,
        },
      };
      break;
    case 'SET_DATE_RANGE_FILTER':
      newState = {
        ...state,
        queryParameters: {
          ...state.queryParameters,
          dateRange: payload.dateRange,
          dateRangeOffset: payload.dateRangeOffset,
        },
        graphParameters: {
          ...state.graphParameters,
          granularity: payload.granularity,
        },
      };
      break;
    case 'SET_GRANULARITY':
      newState = {
        ...state,
        graphParameters: {
          ...state.graphParameters,
          granularity: payload.granularity,
        },
      };
      break;
    case 'SET_LOADING':
      newState = {
        ...state,
        loading: payload.isLoading,
      };
      break;
    case 'SET_COMPARISON_SALES_TOTALS':
      newState = {
        ...state,
        data: {
          ...state.data,
          comparisonSalesTotals: payload.salesTotals,
        },
      };
      break;
    case 'SET_SALES_TOTALS':
      newState = {
        ...state,
        data: {
          ...state.data,
          salesTotals: payload.salesTotals,
        },
      };
      break;
    case 'STORE_CURRENCIES':
      newState = {
        ...state,
        currencies: payload.currencies,
      };
      break;
    case 'UPDATE_COMPARISON_DATE_TARGET':
      const tzComparisonDateMoment = timeNow(state.graphParameters.timezone);
      newState = {
        ...state,
        comparisonDateTarget: getComparisonFromToUrlSegment(state.queryParameters, tzComparisonDateMoment),
      };
      break;
    case 'UPDATE_DATE_TARGET':
      const tzDateMoment = timeNow(state.graphParameters.timezone);
      newState = {
        ...state,
        dateTarget: getFromToUrlSegment(state.queryParameters, tzDateMoment),
      };
      break;
    case 'UPDATE_QUERYSTRING':
      newState = {
        ...state,
        queryString: getQueryString(state.queryParameters, state.graphParameters),
      };
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
  return newState;
}
